<template>
  <div
    class="md-card md-card-product"
    @mouseleave="onMouseLeave"
    :data-count="hoverCount"
  >
    <div
      @mouseenter="onMouseOver"
      :data-header-animation="headerAnimation"
      :class="[
        { hovered: imgHovered },
        { hinge: headerDown },
        { fadeInDown: fixedHeader },
      ]"
      class="md-card-header md-card-header-image animated"
    >
      <slot name="imageHeader"></slot>
    </div>

    <div class="md-card-content">
      <div
        class="md-card-action-buttons text-center"
        v-if="headerAnimation === 'true'"
      >
        <button
          class="md-button md-danger md-simple fix-broken-card"
          @click="fixHeader"
          v-if="headerDown"
        >
          <slot name="fixed-button"></slot> Fix Header!
        </button>
        <button class="md-button md-simple md-just-icon">
          <slot name="first-button"></slot>
        </button>
        <button class="md-button md-success md-simple md-just-icon">
          <slot name="second-button"></slot>
        </button>
        <button class="md-button md-danger md-simple md-just-icon">
          <slot name="third-button"></slot>
        </button>
      </div>
      <slot name="title"></slot>
      <slot name="description"></slot>
    </div>

    <div class="md-card-actions" style="justify-content: space-between;">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-card",
  props: {
    headerAnimation: {
      type: String,
      default: "true",
    },
  },
  data() {
    return {
      hoverCount: 0,
      imgHovered: false,
      fixedHeader: false,
    };
  },
  computed: {
    headerDown() {
      return this.hoverCount > 15;
    },
  },
  methods: {
    headerBack: function () {
      this.fixedHeader = false;
    },
    fixHeader: function () {
      this.hoverCount = 0;
      this.fixedHeader = true;

      setTimeout(this.headerBack, 480);
    },
    onMouseOver: function () {
      if (this.headerAnimation === "true") {
        this.imgHovered = true;
        this.hoverCount++;
      }
    },
    onMouseLeave: function () {
      if (this.headerAnimation === "true") {
        this.imgHovered = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
